import { debounce } from './common';

const searchKeyword = (element, keyword) => {
  // Regular expression to strip HTML tags
  const stripHtmlTag = /(<([^>]+)>)/ig;

  // Get all elements if it's a NodeList or HTMLCollection, otherwise treat as a single element
  const elements = (element instanceof NodeList || element instanceof HTMLCollection) ? Array.from(element) : [element];

  // Setting the search text by stripping HTML tags, replacing elements with space, and converting to lowercase
  // (This is done to add space between text() of different tags which otherwise will come together)
  const searchText = elements.map((el) => {
    return el.innerHTML.replace(stripHtmlTag, ' ');
  }).join(' ').toLowerCase();

  // Match condition: the search text must start or end with the keyword (not just match within words)
  return searchText.includes(` ${keyword}`) || searchText.includes(`${keyword} `);
};

const filterFeaturesPerFeatureCategory = (collapsedFeaturesList, openFeaturesList, searchTerm) => {
  // Convert NodeLists to arrays and process them
  const openFeaturesArray = Array.from(openFeaturesList);
  const collapsedFeaturesArray = Array.from(collapsedFeaturesList);

  // Process each feature and determine visibility
  openFeaturesArray.forEach((currentOpenFeature, index) => {
    const currentCollapsedFeature = collapsedFeaturesArray[index];
    const shouldShow = searchKeyword(currentOpenFeature, searchTerm);
    const displayStyle = shouldShow ? '' : 'none';

    // Update visibility for both collapsed and open features
    if (currentCollapsedFeature?.style) {
      currentCollapsedFeature.style.display = displayStyle;
    }
    
    if (currentOpenFeature?.style) {
      currentOpenFeature.style.display = displayStyle;
    }
  });
};

const liveSearch = (featureCategoriesList, featureCategoriesOriginalState, featureSearchInput) => {
  const debouncedSearch = debounce((event) => {
    const searchTerm = event.target.value.toLowerCase();

    // Show/hide the "no result found" div with null check
    const noResultDiv = document.querySelector('.no-result-found');
    if (noResultDiv) {
      if (!searchKeyword(featureCategoriesList, searchTerm)) {
        noResultDiv.classList.remove('d-none');
      } else {
        noResultDiv.classList.add('d-none');
      }
    }

    // Resetting featureCategoriesList if search is cleared
    featureCategoriesList = (searchTerm === '') ? featureCategoriesOriginalState : featureCategoriesList;

    // Show/hide the close button based on whether search is empty with null check
    const closeBtn = document.querySelector('.search-box .close-btn');
    if (closeBtn) {
      closeBtn.style.display = searchTerm === '' ? 'none' : 'block';
    }

    // Show/hide background elements
    const backgroundElements = document.querySelectorAll('.circles-left-right-bg-v2, .feature-sublist-description-list .bullet-points, .dots-bg');
    backgroundElements.forEach((el) => {
      if (searchTerm === '') {
        el.style.display = 'flex';
        el.classList.add('d-flex');
      } else {
        el.style.display = 'none';
        el.classList.remove('d-flex');
      }
    });

    // Process each feature-category section with modern ES6 approach
    Array.from(featureCategoriesList)
      .filter((element) => element) // Filter out any null elements
      .forEach((element) => {
        const shouldShowCategory = searchKeyword(element, searchTerm);
        
        if (shouldShowCategory) {
          const collapsedFeaturesList = element.querySelectorAll('.feature-collapse');
          const openFeaturesList = element.querySelectorAll('.feature-open');
          
          filterFeaturesPerFeatureCategory(collapsedFeaturesList, openFeaturesList, searchTerm);
          element.style.display = '';
        } else {
          element.style.display = 'none';
        }
      });
  }, 500);

  // Attach debounced search to keyup event
  featureSearchInput.addEventListener('keyup', debouncedSearch);
};

// Get feature-category sections in an array
const featureCategoriesList = document.querySelectorAll('.feature-category');

// Set feature search input to a variable
const featureSearchInput = document.getElementById('feature-search');

const searchFilter = () => {
  if (!featureSearchInput) {
    return;
  }

  // Store the original feature category state
  const featureCategoriesOriginalState = featureCategoriesList;

  // Enable live search
  liveSearch(featureCategoriesList, featureCategoriesOriginalState, featureSearchInput);

  // Allow clicking on suggested terms to populate search input
  const suggestionTerms = document.querySelectorAll('.feature-suggestion-term');
  suggestionTerms.forEach((term) => {
    term.addEventListener('click', (event) => {
      const featureSuggestionTerm = event.target.textContent;
      featureSearchInput.value = featureSuggestionTerm;

      // Trigger keyup event programmatically
      featureSearchInput.dispatchEvent(new Event('keyup'));
    });
  });
};

const clearSearchItem = () => {
  // Clear search input and trigger keyup to reset with null check
  const featureSearchInput = document.getElementById('feature-search');
  if (featureSearchInput) {
    featureSearchInput.value = '';
    featureSearchInput.dispatchEvent(new Event('keyup'));
  }
};

// Make clearSearchItem available globally
window.clearSearchItem = clearSearchItem;

export {
  searchFilter
};